import React from 'react';

const HBGHPL = () => {
    return (
        <div className="container mx-auto px-4 py-12">
            <h1 className="text-3xl font-bold text-[#1E3A8A] mb-8">HBG diatas HPL</h1>
            <div className="card-glass">
                <h2 className="text-xl font-bold text-[#0D9488] mb-4">Informasi HBG diatas HPL</h2>
                <p className="text-gray-700 mb-4">
                    Halaman ini berisi informasi tentang Hak Guna Bangunan (HGB) di atas Hak Pengelolaan Lahan (HPL).
                </p>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-6">
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Persyaratan</h3>
                        <ul className="list-disc list-inside space-y-1 text-gray-600">
                            <li>Fotokopi KTP</li>
                            <li>Sertifikat HPL</li>
                            <li>Surat Permohonan</li>
                            <li>Proposal Penggunaan</li>
                        </ul>
                    </div>
                    <div className="bg-gray-50 p-4 rounded-lg">
                        <h3 className="font-semibold text-[#1E3A8A] mb-2">Prosedur</h3>
                        <ol className="list-decimal list-inside space-y-1 text-gray-600">
                            <li>Pengajuan permohonan</li>
                            <li>Verifikasi dokumen</li>
                            <li>Survey lapangan</li>
                            <li>Penerbitan izin</li>
                        </ol>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HBGHPL;